import { QueryOptions, useQuery } from "@tanstack/react-query";
import { fetchPotentialExceptions, PotentialExceptionsParams } from "PFCore/services/audit_planner";
import { AuditPlannerExceptionsDictionary } from "PFCore/types";

import { potentialExceptionsKeys } from "./query_keys";

type UsePotentialExceptions = {
  params: Partial<PotentialExceptionsParams>;
  options?: QueryOptions<AuditPlannerExceptionsDictionary>;
};

export const usePotentialExceptions = ({ params, options }: UsePotentialExceptions) =>
  useQuery({
    ...options,
    queryKey: potentialExceptionsKeys.withParameters({
      profileId: params.profileId!,
      activityId: params.activityId!,
      bookingsIds: params.bookingsIds
    }),
    queryFn: () =>
      fetchPotentialExceptions({
        profileId: params.profileId!,
        activityId: params.activityId!,
        bookingsIds: params.bookingsIds
      }),
    enabled: !!params.profileId && !!params.activityId
  });
